import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['siren'];

  // Autofills Company Data based on SIREN number
  autofill() {
    if (this.sirenTarget.value > 9999999999999 && this.sirenTarget.value < 100000000000000 ) {
      fetch(`https://entreprise.data.gouv.fr/api/sirene/v3/etablissements/${this.sirenTarget.value}`)
        .then(response => response.json())
        .then((data) => {
          const name = document.getElementById('user_company_attributes_name') ? document.getElementById('user_company_attributes_name') : document.getElementById('company_name');
          const legalName = document.getElementById('user_company_attributes_legal_name') ? document.getElementById('user_company_attributes_legal_name') : document.getElementById('company_legal_name');

          name.setAttribute('value', data.etablissement.unite_legale.denomination);
          legalName.setAttribute('value', data.etablissement.unite_legale.denomination);
        });
    }
  }

}
